import React, {Component} from 'react'
import DeleteSku from './../actions/DeleteSku'
import PropTypes from 'prop-types'

class Actions extends Component {
    render() {
        const {item, onRefresh} = this.props

        return (
            <td className="Actions">
                <div className="d-flex align-items-center">
                    <DeleteSku itemId={item._id} name={item.name} onRefresh={onRefresh}/>
                </div>
            </td>
        )
    }
}

Actions.propTypes = {
    item: PropTypes.object.isRequired,
    onRefresh: PropTypes.func.isRequired
}

export default Actions